import { fg } from '@atlaskit/platform-feature-flags';

import { getJiraWorkItemKeyFromActivity } from '../../../common/ui/quick-find/get-jira-work-item-key-from-activity';
import { getJiraWorkItemKeyFromSearchResult } from '../../../common/ui/quick-find/get-jira-work-item-key-from-search-result';
import { normalizeWorkItemKey } from '../../../common/ui/quick-find/normalize-work-item-key';
import type { RecentActivityItem, SearchResultItem } from '../../../common/ui/quick-find/types.tsx';

const MIN_QUERY_LENGTH = 2;

export const isQueryMatchingActivityKey = (
	query: string,
	item: RecentActivityItem,
): RecentActivityItem | undefined => {
	const itemKey = getJiraWorkItemKeyFromActivity(item);
	if (query.length >= MIN_QUERY_LENGTH && itemKey) {
		const itemKeyFromQuery = fg('search_qf_issue_key_variants')
			? normalizeWorkItemKey(query.trim())
			: query.trim().toLowerCase();

		if (itemKeyFromQuery === itemKey?.toLowerCase()) {
			return item;
		}
	}
	return undefined;
};

export const isQueryMatchingSearchResultKey = (
	query: string,
	item: SearchResultItem,
): SearchResultItem | undefined => {
	const itemKey = getJiraWorkItemKeyFromSearchResult(item);
	if (query.length >= MIN_QUERY_LENGTH && itemKey) {
		const itemKeyFromQuery = fg('search_qf_issue_key_variants')
			? normalizeWorkItemKey(query.trim())
			: query.trim().toLowerCase();

		if (itemKeyFromQuery === itemKey?.toLowerCase()) {
			return item;
		}
	}
	return undefined;
};
